/**
 * Product video auto-play on active slide.
 * - Poster image loads normally (lazy).
 * - Video content template stays deferred until the slide becomes visible.
 * - On slide-active → showDeferredMedia (loads + plays muted).
 * - On slide-inactive → pauseMedia (frees decoder).
 * Zero network cost until user reaches the video slide.
 */
(function () {
  function initGallery(gallery) {
    if (gallery.__videoAutoInit) return;
    gallery.__videoAutoInit = true;

    var slides = gallery.querySelectorAll('slideshow-slide');
    if (!slides.length) return;

    slides.forEach(function (slide) {
      var deferred = slide.querySelector('deferred-media[autoplay]');
      if (!deferred) return;
      handleSlide(slide, deferred);
    });
  }

  function handleSlide(slide, deferred) {
    // Track current visibility via aria-hidden attribute
    var active = slide.getAttribute('aria-hidden') === 'false';
    if (active) triggerPlay(deferred);

    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'aria-hidden') {
          var isActive = slide.getAttribute('aria-hidden') === 'false';
          if (isActive) triggerPlay(deferred);
          else triggerPause(deferred);
        }
      }
    });
    mo.observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function triggerPlay(deferred) {
    if (!deferred) return;
    // If not yet loaded, showDeferredMedia will inject the <video> from <template>
    if (!deferred.getAttribute('data-media-loaded') && typeof deferred.showDeferredMedia === 'function') {
      deferred.showDeferredMedia();
    }
    // Wait a tick for the video element to be attached, then play (bypasses
    // MediaStartedPlayingEvent side-effects and browser autoplay rejects)
    var attempt = 0;
    (function play() {
      var v = deferred.querySelector('video');
      if (v && v.readyState >= 2) {
        v.muted = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        return;
      }
      if (attempt++ < 30) setTimeout(play, 100);
    })();
  }

  function triggerPause(deferred) {
    if (!deferred) return;
    if (typeof deferred.pauseMedia === 'function') deferred.pauseMedia();
    else {
      var v = deferred.querySelector('video');
      if (v) try { v.pause(); } catch (_) {}
    }
  }

  function scan() {
    document.querySelectorAll('media-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Re-scan on Shopify section reload (Theme Editor)
  document.addEventListener('shopify:section:load', scan);
})();
